// K13 (Finar — çok bloklu Excel, 2026-10-23) — içe aktarma grid'inde satır/sayfa sınıfları; BE
// (öneri varsayılanı, ilk taslak) ve FE (rozet, sayfa notu) AYNI kuralı buradan okur.
import type { KpiImportGrid, KpiImportSheet } from "../schemas/kpi-import.js";
import { normalizeMappingLabel } from "./kpi-code.js";

// `normalizeMappingLabel` çıktısıyla (TR katlanmış, sondaki birim parantezi/dipnot düşmüş)
// karşılaştırılır: "Toplam", "TOPLAM (sayı)", "Genel Toplam", "Toplam – İşe Alınan", "Total".
// "Toplam Enerji Tüketimi" / "Toplam Çalışan Sayısı" gibi ADLANDIRILMIŞ göstergeler toplam satırı
// DEĞİLDİR — müşterinin kendi girdiği asıl KPI'dır (kural yalnız çıplak toplam + nitelik ekidir).
const TOTAL_ROW_RE = /^(?:genel\s+)?(?:toplam|total|grand\s+total)(?:\s*[-–—:].*)?$/u;

/**
 * Satır, üstündeki kırılımların toplamı mı ("Toplam", "Genel toplam", "Toplam – …")? Bu satırlar
 * sistemin hesapladığı ara toplam/konsolide ile çakışır → öneri varsayılanı "atla" ("sistem
 * hesaplar" rozeti); kullanıcı isterse dahil eder.
 */
export function isTotalRow(label: string): boolean {
  return TOTAL_ROW_RE.test(normalizeMappingLabel(label));
}

/** Sayfa türü — alan yoksa `data`. */
export function sheetKindOf(sheet: Pick<KpiImportSheet, "kind">): "data" | "notes" {
  return sheet.kind ?? "data";
}

/** Not/açıklama sayfalarının grid dizi indeksleri (ilk taslakta otomatik atlanır). */
export function notesSheetIndexes(grid: KpiImportGrid): number[] {
  return grid.sheets.map((s, i) => (sheetKindOf(s) === "notes" ? i : -1)).filter((i) => i >= 0);
}

/** Eşleştirme notu: toplam satırı (öneri varsayılanı atla). Müşteri portalında da görünür. */
export const KPI_TOTAL_ROW_NOTE = "sistem hesaplar — toplam satırı";
/** Eşleştirme notu: not/açıklama sayfası satırı (sayfa otomatik atlanır). */
export const KPI_NOTES_SHEET_NOTE = "not sayfası";
/** Eşleştirme notu: toplam satırı ama kardeşlerinin toplamı değil (oran / kaynak tutarsızlığı) — normal eşleşir. */
export const KPI_TOTAL_ROW_KEEP_NOTE = "Toplam satırı — kaynak rakamı korunur";
